import { render, staticRenderFns } from "./OrderServiceCommentsClient.vue?vue&type=template&id=cba236dc&scoped=true&"
import script from "./OrderServiceCommentsClient.vue?vue&type=script&lang=js&"
export * from "./OrderServiceCommentsClient.vue?vue&type=script&lang=js&"
import style0 from "./OrderServiceCommentsClient.vue?vue&type=style&index=0&id=cba236dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba236dc",
  null
  
)

export default component.exports